var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatplotlibSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 14 14",
    role: "img",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cfd8dc",
    d: "M1.00000008 12.99999994h11.9999999v-.68571428H1.68571436V1.00000004h-.68571428z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00bcd4",
    transform: "translate(-1.3999999 -1.0571428) scale(.34286)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 11,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 13,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 19,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 26,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 20,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 28,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 23,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 33,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 30,
    r: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatplotlibSvg);
export default __webpack_public_path__ + "static/media/matplotlibSVG.4b2fc562274b677db064a4338c7e1508.svg";
export { ForwardRef as ReactComponent };